var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSpark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.9378 32.4409C49.0289 32.4409 50.7498 31.3533 50.9821 29.949L53.0476 6.60255C53.0476 4.29445 50.3463 2.4 46.9455 2.4C43.5497 2.4 40.851 4.29445 40.851 6.60255L42.9114 29.949C43.1412 31.3533 44.8621 32.4409 46.9455 32.4409H46.9373",
    fill: "#FDBB30"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.32 39.7328C35.3693 37.9251 35.2876 35.8903 34.1848 34.989L14.995 21.5286C13.0008 20.3746 10.0085 21.766 8.31061 24.7099C6.60762 27.6485 6.90891 30.9345 8.90038 32.0886L30.1455 41.9822C31.4757 42.475 33.2859 41.5277 34.3276 39.7201L34.3195 39.7323",
    fill: "#FDBB30"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M59.5659 39.7201C60.6127 41.5278 62.4153 42.475 63.7455 41.9822L84.9932 32.0886C86.9949 30.9345 87.2808 27.6487 85.5906 24.7099C83.8851 21.7661 80.8876 20.3746 78.8987 21.5286L59.7089 34.9891C58.611 35.8903 58.5293 37.9253 59.5737 39.7328L59.5655 39.7206",
    fill: "#FDBB30"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M46.9378 61.601C49.0289 61.601 50.7498 62.681 50.9821 64.0853L53.0476 87.4291C53.0476 89.7423 50.3463 91.6342 46.9455 91.6342C43.5497 91.6342 40.851 89.7423 40.851 87.4291L42.9114 64.0853C43.1412 62.681 44.8621 61.601 46.9455 61.601H46.9373",
    fill: "#FDBB30"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M59.5659 54.3134C60.6127 52.5032 62.4153 51.5611 63.7455 52.0615L84.9931 61.9449C86.9949 63.1014 87.2808 66.3899 85.5906 69.3338C83.8851 72.2674 80.8876 73.6614 78.8987 72.51L59.7089 59.0623C58.611 58.1507 58.5293 56.1159 59.5737 54.3109L59.5655 54.3129",
    fill: "#FDBB30"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M34.32 54.3109C35.3693 56.1159 35.2876 58.1509 34.1848 59.0623L14.995 72.51C13.0009 73.6615 10.0086 72.2675 8.31069 69.3338C6.60761 66.39 6.9089 63.1016 8.90037 61.9449L30.1455 52.0615C31.4757 51.5611 33.2859 52.5032 34.3276 54.3134L34.3195 54.3114",
    fill: "#FDBB30"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpark);
export default __webpack_public_path__ + "static/media/spark.6a31c297b9efb0205aab8b53a5cbda2f.svg";
export { ForwardRef as ReactComponent };